/// <reference types="jquery" />
/// <reference types="jquery.validation" />

import './vendor';
import { loadRecaptchaToeken, submitSafe } from './util/SafeUtils';

$(function () {
  $('#resetInvitationForm').validate({
    rules : {
      loginId: {
        required: true,
        minlength: 1,
        maxlength: 256
      },
      email: {
        required: true,
        email: true,
        minlength: 1,
        maxlength: 256
      },
      errorPlacement: function (error: JQuery , element: JQuery) {
        error.insertAfter(element);
      }
    }
  });

  const sitekey: any = $('meta[name=sitekey]').attr('content');
  loadRecaptchaToeken(sitekey, '#loading', '#gtoken')
  $('#submitButton').on('click', submitSafe);

  // フォーカスをIDに合わせる
  $('#loginId').focus();
});